import { gql } from '@utils/gpl-dedup';

export const taskFragment = gql`
  fragment task on Task {
    id
    subject
    description
    status
    due_date
    completed_at
    related_link
    related_link_title
    updated_at
    created_at
  }
`;
